import axiosClient from './axiosClient';
import {
  IPagination,
  IPagingResponse,
  IResponseT,
} from 'interface/base.interface';
import {
  IProduct,
  IProductGroup,
  IProductImageReponse,
  InsertProductForPortFolio,
} from 'interface/product.interface';
const path = 'abe/product';

const ProductApi = {
  get: (params?: any): Promise<IPagingResponse<IProduct>> => {
    return axiosClient.get(`/${path}/get-many`, { params });
  },

  getyDetail: (
    code: string,
    params?: IPagination
  ): Promise<IPagingResponse<IProduct>> => {
    return axiosClient.get(`/${path}/get-by-code?product_code=${code}`, {
      params,
    });
  },
  getProductGroup: (
    grp_level: number
  ): Promise<IPagingResponse<IProductGroup>> => {
    return axiosClient.get(`/${path}/product-group?grp_level=${grp_level}`);
  },

  getProductOption: (): Promise<any> => {
    return axiosClient.get(`/${path}/option-list`);
  },

  getListImage: (code: string): Promise<IProductImageReponse> => {
    return axiosClient.get(`/${path}/get-list-image?product_code=${code}`);
  },

  syncImageAndBOM: (params: any) => {
    return axiosClient.post(`/${path}/sync-image-bom`, params);
  },

  deleteImage: (id: number) => {
    return axiosClient.delete(`/${path}/product-image?id=${id}`);
  },

  uploadImage: ({
    product_code,
    files,
  }: {
    product_code: string;
    files: File[];
  }) => {
    const data = new FormData();
    data.append('product_code', product_code);
    files.forEach((file, index) => {
      data.append(`file[${index}]`, file);
    });
    return axiosClient.post(`${path}/upload-product-image`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  insertProductForPortfolio: (
    data: InsertProductForPortFolio
  ): Promise<any> => {
    return axiosClient.post(`/${path}/insert-product-for-portfolio`, data);
  },

  updateProductList: (data: any): Promise<IResponseT<any>> => {
    const list_product = { list_product: data };
    return axiosClient.put(`/${path}/update-list`, list_product, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  postGCP: (data: any) => {
    return axiosClient.post(
      `abe/product/insert-product-for-portfolio-from-gcp`,
      data
    );
  },
};

export default ProductApi;
